export default "__VITE_ASSET__Dk_j7GKu__"